define(["authui/iamEnv"], function (iamEnv) {
    "use strict";

    function getAjaxConf() {
        return {
            timeout: 10 * 60 * 1000,
            headers: {
                "Pragma": "no-store",
                "Cache-control": "no-store"
            },
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            data: {}
        };
    };
    var supportType = ["GET", "POST", "PUT", "DELETE", "PATCH"];

    function iamAjax(reqType) {
        return function (config) {
            var deferred = $.Deferred();
            adaptConfig(config);
            if (iamEnv.getUrlPrefix() !== undefined) {
                config.url = iamEnv.getUrlPrefix() + config.url;
            }
            var ajaxConf = getAjaxConf();
            $.extend(true, ajaxConf, config);
            ajaxConf["type"] = reqType;

            var ajax = $.ajax(ajaxConf);
            ajax.success(function () {
                deferred.resolve(arguments[0]);
            }).error(function() {
                deferred.reject(arguments[0]);
            });
            return deferred.promise();
        };
    }

    //adapt earlier implement
    function adaptConfig(config) {
        if (config.params) {
            config.data = config.params;
            delete config.params;
        }
        if (config.header) {
            config.headers = config.header;
            delete config.header;
        }
    }

    var iamHttpService = {};

    for (var i = 0; i < supportType.length; i++) {
        iamHttpService[supportType[i].toLowerCase()] = iamAjax(supportType[i]);
    }

    return iamHttpService;
});


// WEBPACK FOOTER //
// ./public/base/utils/iamHttpService.js